import { useEffect, useRef } from 'react';
import styles from './Thanks.module.css';

export default function Thanks() {
    const sectionRef = useRef(null);
    const text = "Grazie!";

    useEffect(() => {
        // 1. Salva il riferimento corrente in una variabile locale
        const currentSectionRef = sectionRef.current;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(styles.show);
                        // Opzionale: smetti di osservare dopo la prima animazione
                        observer.unobserve(entry.target); 
                    }
                });
            },
            { threshold: 0.5 } // L'animazione parte quando il 50% è visibile
        );

        if (currentSectionRef) {
            observer.observe(currentSectionRef);
        }

        // 2. Usa la variabile locale nella funzione di pulizia
        return () => {
            if (currentSectionRef) {
                observer.unobserve(currentSectionRef);
            }
        };
    }, []);

    return (
        <section className={styles.thanksSection} ref={sectionRef}>
            <h1 className={styles.thanksText}>
                {/* Mappiamo la parola "Grazie!" per animare ogni lettera */}
                {text.split('').map((char, index) => (
                    <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                        {char}
                    </span>
                ))}
            </h1>
        </section>
    );
}
